import { render, staticRenderFns } from "./AppointmentDashboard.vue?vue&type=template&id=40d6d42b&scoped=true&"
import script from "./AppointmentDashboard.vue?vue&type=script&lang=js&"
export * from "./AppointmentDashboard.vue?vue&type=script&lang=js&"
import style0 from "./AppointmentDashboard.vue?vue&type=style&index=0&id=40d6d42b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d6d42b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VChip,VDataTable,VIcon,VProgressCircular,VTooltip})
